import React, {useEffect, useState} from "react";
import styled from "styled-components";
import NoChoice2 from "../../img/NoChoice2.png"
import Choice2 from "../../img/Choice2.png"
import { useCookies } from "react-cookie";

const Styled={
    Wrap:styled.div`
        width:100%;
        height:100%;
        position:fixed;
        top:0px;
        background-color:#000000;
        opacity:50%;
        z-index:4;
    `,
    WrapBox:styled.div`
        width:88.8%;
        height:418px;
        background-color:#ffffff;
        position:fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index:5;
        border-radius:10px;
        display:flex;
        justify-content:center;
        align-items:center;
        flex-direction:column;
    `,
        ContentsBox:styled.div`
            width:90%;
            height:90%;
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            flex-direction:column;
        `,

            TextContentsWrap:styled.div`
                width:100%;
                height:258px;
                display:flex;
                justify-content:space-between;
                align-items:flex-start;
                flex-direction:column;
            `,
                HeaderWrap:styled.div`
                    width:100%;
                    height:28px;
                `,
                    Header:styled.p`
                        font-size:20px;
                        font-weight:600;
                        color:#222222;
                        margin:0px;
                        font-family:'PreFont';
                    `,
                TextContentsBox:styled.div`
                    width:100%;
                    height:220px;
                    display:flex;
                    justify-content:space-between;
                    align-items:flex-start;
                    flex-direction:column;
                `,
                    NumWrap:styled.div`
                        width:100%;
                        height:40px;
                        display:flex;
                        justify-content:flex-start;
                        align-items:flex-start;
                        flex-direction:row;
                    `,
                    NumWrap2:styled.div`
                        width:100%;
                        height:20px;
                        display:flex;
                        justify-content:flex-start;
                        align-items:flex-start;
                        flex-direction:row;
                    `,
                        NumText:styled.p`
                            font-size:14px;
                            font-weight:400;
                            color:#222222;
                            margin:0px;
                            font-family:'PreFont';
                        `,
                        TextContents:styled.p`
                            font-size:14px;
                            font-weight:400;
                            color:#222222;
                            margin:0px;
                            font-family:'PreFont';
                        `,
            AgreeWrap:styled.div`
                width:100%;
                height:24px;
                display:flex;
                justify-content:flex-start;
                align-items:center;
                flex-direction:row;
            `,
                AgreeBox:styled.div`
                    width:24px;
                    height:24px;
                    &:hover{
                        cursor:pointer;
                    }
                `,
                    AgreeImg:styled.img`
                        width:100%;
                        height:100%;
                    `,
                AgreeText:styled.p`
                    font-size:14px;
                    font-weight:400;
                    color:${({ isActive }) => (isActive ? "#2277F6" : "#767676")};
                    margin:0px 0px 0px 5px;
                    font-family:'PreFont';
                `,

        
            CallBtn:styled.div`
                width:100%;
                height:56px;
                border-radius:10px;
                background-color: ${({ isActive }) => (isActive ? "#2277F6" : "#999999")};
                display:flex;
                justify-content:center;
                align-items:center;
                flex-direction:row;
                margin-top:10px;
            `,
                BtnText:styled.p`
                    font-size:16px;
                    font-weight:400;
                    color:#ffffff;
                    margin:0px;
                    font-family:'PreFont';
                `,
}
const FirstAlert=(props)=>{
    const {AlertOpen, setAlertOpen, NowLang, restaurantLocation} = props
    const [location, setLocation] = useState({ lat: null, lng: null });
    const [GPSCookie, setGPSCookie, removeGPSCookie] = useCookies(["GPSClosed"]);

    const [isChecked, setIsChecked] = useState(false);
    const [isInRange, setIsInRange] = useState(false);

    useEffect(() => {
        console.log(restaurantLocation)
        if (isChecked) {
            if (!navigator.geolocation) {
                alert("이 브라우저는 위치 정보를 지원하지 않습니다.");
                return;
            }
    
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const myLat = position.coords.latitude;
                    const myLng = position.coords.longitude;
    
                    const distance = getDistanceFromLatLonInMeters(
                        myLat,
                        myLng,
                        restaurantLocation.lat,
                        restaurantLocation.lng
                    );
    
                    console.log(`현재 거리: ${distance.toFixed(2)}m`);
                    if (distance > 1500000) {
                        alert("1500m 이내에 있지 않습니다. 서비스를 이용할 수 없습니다.");
                        setIsInRange(false);
                        setIsChecked(false)
                    } else {
                        console.log("🎯 반경 1500m 이내입니다.");
                        setIsInRange(true);
                    }
                },
                (error) => {
                    console.error("위치 정보 에러:", error);
                    alert("위치 정보를 가져오지 못했습니다.");
                }
            );
        } else {
            setIsInRange(false); // 체크 해제하면 인증도 초기화
        }
    }, [isChecked]);


    function getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
        const R = 6371000; // 지구 반지름 (m)
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) *
            Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }
// 좌표 계산 함수

    useEffect(() => {
        // 쿠키가 있으면 이벤트를 숨김
        const eventClosed = GPSCookie.GPSClosed;
        console.log(GPSCookie)
        if (eventClosed && new Date().getTime() < eventClosed) {
            setAlertOpen(false); // 1시간 이내면 이벤트를 숨김
        }else{
            setAlertOpen(true);
        }
    }, [GPSCookie]);


    const handleCloseToday = () => {
        // 5시간 후에 이벤트가 보이지 않도록 쿠키에 설정
        const threeHoursLater = new Date().getTime() + 5 * 60 * 60 * 1000; // 5시간 후
        setGPSCookie("GPSClosed", threeHoursLater, { path: "/" }); // 쿠키 설정
        setAlertOpen(false); // 이벤트 숨김
    };

    useEffect(()=>{
        const saved_uuid_data = localStorage.getItem("uuid_data");
        if(saved_uuid_data === null){
            const id = crypto.randomUUID();
            localStorage.setItem("uuid_data", JSON.stringify(id));
        }
    },[])

    if(AlertOpen === false){
        return(
            <></>
        )
    }else{
        return(
            <>
                <Styled.Wrap/>
                <Styled.WrapBox>
                    <Styled.ContentsBox>
                        <Styled.TextContentsWrap>
                            <Styled.HeaderWrap>
                                <Styled.Header>꼭 확인해주세요!</Styled.Header>
                            </Styled.HeaderWrap>
                            <Styled.TextContentsBox>
                                <Styled.NumWrap>
                                    <Styled.NumText>1.&nbsp;</Styled.NumText>
                                    <Styled.NumText>원하는 메뉴를 장바구니에 담고 결제하여 주문을 완료해주세요(여럿이서 주문도 OK!)</Styled.NumText>
                                </Styled.NumWrap>
                                <Styled.NumWrap>
                                    <Styled.NumText>2.&nbsp;</Styled.NumText>
                                    <Styled.NumText>웹 페이지를 종료하지 않으면 QR코드를 새로 촬영하지 않아도 돼요(귀찮음 방지!)</Styled.NumText>
                                </Styled.NumWrap>
                                <Styled.NumWrap2>
                                    <Styled.NumText>3.&nbsp;</Styled.NumText>
                                    <Styled.NumText>만 19세 미만은 주류판매를 금지하고있어요</Styled.NumText>
                                </Styled.NumWrap2>
                                <Styled.NumWrap>
                                    <Styled.NumText>4.&nbsp;</Styled.NumText>
                                    <Styled.NumText>결제완료 후 조리가 시작되면 환불이 어려우니 양해 부탁드려요</Styled.NumText>
                                </Styled.NumWrap>
                                <Styled.NumWrap>
                                    <Styled.NumText>5.&nbsp;</Styled.NumText>
                                    <Styled.NumText>위치정보를 동의하지 않으면 주문서비스를 이용할 수 없어요</Styled.NumText>
                                </Styled.NumWrap>
                            </Styled.TextContentsBox>
                        </Styled.TextContentsWrap>
                        <Styled.AgreeWrap>
                            <Styled.AgreeBox
                                onClick={() => setIsChecked(!isChecked)}
                            >
                                <Styled.AgreeImg src={isChecked === false ? NoChoice2:Choice2}/>
                            </Styled.AgreeBox>
                            <Styled.AgreeText
                            >위 사항을 이해했으며 이에 동의합니다.</Styled.AgreeText>
                        </Styled.AgreeWrap>
                        <Styled.CallBtn
                            isActive={isChecked && isInRange}
                            onClick={() => {
                                if (!isChecked) {
                                    alert("안내사항에 동의해주세요");
                                    return;
                                }
                        
                                if (!isInRange) {
                                    alert("위치 인증이 필요합니다.");
                                    return;
                                }
                                if(isChecked && isChecked){
                                    handleCloseToday(); // 조건 만족 시 알림창 닫기 & 쿠키에 저장
                                }
                            }}
                        >
                            <Styled.BtnText>주문하러가기</Styled.BtnText>
                        </Styled.CallBtn>
                    </Styled.ContentsBox>
                </Styled.WrapBox>
            </>
        )
    }
    
}
export default FirstAlert